import React from 'react';
import {
    PersonFill,
    BoxArrowRight,
    PersonCircle,
    Download,
    ShieldLock,
    Grid,
    PencilSquare,
    Incognito,
    CloudFill,
    People,
    Receipt,
    FlaskFlorence,
    Mortarboard,
} from "react-bootstrap-icons";
import inventoryIcon from "../../assets/images/icons/gray-icons/Icon-Plasmid inventory and preview.svg";
import shareIcon from "../../assets/images/icons/gray-icons/Icon-Collaborate.svg";
import crisprIcon from "../../assets/images/icons/gray-icons/Icon-CRISPR-Cas gene editing tools.svg";
import cloudDeskIcon from "../../assets/images/icons/gray-icons/Icon-Desktop and cloud.svg";
import sparkLogo from "../../assets/images/logos/spark-logo.svg";
import photo51Logo from "../../assets/images/logos/photo51-blue-desktop-icon.svg";


const StandardIcons = {
    OffLineOnline: ({ width }: { width?: number }) => <img alt="offline icon" src={cloudDeskIcon} className={width ? undefined : "w-100"} style={{ width }} />,
    Labels: ({ width }: { width?: number }) => <img alt="folder icon" src={inventoryIcon} className={width ? undefined : "w-100"} style={{ width }} />,
    CrisprCas: ({ width }: { width?: number }) => <img alt="crispr icon" src={crisprIcon} className={width ? undefined : "w-100"} style={{ width }} />,
    LibraryShare: ({ width }: { width?: number }) => <img alt="share icon" src={shareIcon} className={width ? undefined : "w-100"} style={{ width }} />,
    Cloud: CloudFill,
    Subscriptions: Receipt,
    Group: People,
    Logout: BoxArrowRight,
    Security: ShieldLock,
    Download: Download,
    Account: PersonCircle,
    Lims: Grid,
    Research: FlaskFlorence,
    Education: Mortarboard,
    Photo51: ({ width }: { width?: number }) => <img src={photo51Logo} style={{ width }} alt="Photo51 Logo" />,
    Eln: ({ width }: { width?: number }) => <img src={sparkLogo} style={{ width }} alt="Spark ELN Logo" />,
    Edit: PencilSquare,
    AdminEnvironment: Incognito,
    PersonalInformation: PersonFill,
}

export default StandardIcons

